import { useToken } from '@ori/auth';
import { createContext, useContext, useMemo } from 'react';
import { useGetAtpClusterId, useGetCustomerInfo } from '../hooks';
import { jsx as _jsx } from "react/jsx-runtime";
export const UserSegmentationDataContext = /*#__PURE__*/createContext({
  customerTypeId: undefined,
  loading: true,
  visitorSegment: undefined,
  atpClusterId: undefined
});
/**
 * Provider for User Segmentation data.
 * It fetches ATP Cluster ID and Customer Type ID and Visitor Segment for authenticated customers.
 * If you provide `atpClusterId` prop, fetching ATP Cluster ID will be disabled.
 * If you provide `customerTypeId` and `visitorSegment` prop, fetching Customer Type ID and Visitor Segment will be disabled.
 *
 * @param atpClusterId - ATP Cluster ID to use instead of fetching it.
 * @param customerTypeId - Customer Type ID to use instead of fetching it.
 * @param visitorSegment - Visitor Segment to use instead of fetching it.
 **/
export const UserSegmentationDataProvider = ({
  children,
  atpClusterId: atpClusterIdProp,
  customerTypeId: customerTypeIdProp,
  visitorSegment: visitorSegmentProp
}) => {
  const enabledGetAtpClusterId = atpClusterIdProp === undefined;
  const enabledGetCustomerInfo = customerTypeIdProp === undefined;
  const {
    customerId
  } = useToken();
  const {
    atpClusterId,
    error: atpClusterIdError,
    loading: atpClusterIdLoading
  } = useGetAtpClusterId({
    customerId,
    enabled: enabledGetAtpClusterId
  });
  const {
    customerTypeId,
    error: customerInfoError,
    loading: customerInfoLoading,
    visitorSegment
  } = useGetCustomerInfo({
    customerId,
    enabled: enabledGetCustomerInfo
  });
  const data = useMemo(() => ({
    atpClusterId: atpClusterIdProp ?? atpClusterId,
    customerTypeId: customerTypeIdProp ?? customerTypeId,
    visitorSegment: visitorSegmentProp ?? visitorSegment,
    loading: atpClusterIdLoading || customerInfoLoading,
    error: atpClusterIdError ?? customerInfoError
  }), [atpClusterId, atpClusterIdError, atpClusterIdLoading, customerInfoError, customerInfoLoading, customerTypeId, visitorSegment, atpClusterIdProp, customerTypeIdProp, visitorSegmentProp]);
  return /*#__PURE__*/_jsx(UserSegmentationDataContext.Provider, {
    value: data,
    children: children
  });
};
export const useUserSegmentationData = () => useContext(UserSegmentationDataContext);
//# sourceMappingURL=userSegmentationDataContext.js.map